;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export const buttons = [
  { name: 'employers-care-nav-care', link: '#care' },
  { name: 'employers-care-nav-what', link: '#services' },
  { name: 'employers-care-nav-why', link: '#why' },
  { name: 'employers-care-nav-approach', link: '#approach' },
];

export const services = [
  'employers-care-services-item-1',
  'employers-care-services-item-2',
  'employers-care-services-item-3',
  'employers-care-services-item-4',
  'employers-care-services-item-5',
  'employers-care-services-item-6',
];

export const strengths = [
  'employers-care-strengths-item-1',
  'employers-care-strengths-item-2',
  'employers-care-strengths-item-3',
  'employers-care-strengths-item-5',
  'employers-care-strengths-item-4',
];

export const timeline = [
  {
    title: 'employers-care-approach-step-1-title',
    description: 'employers-care-approach-step-1-text',
  },
  {
    title: 'employers-care-approach-step-2-title',
    description: 'employers-care-approach-step-2-text',
  },
  {
    title: 'employers-care-approach-step-3-title',
    description: 'employers-care-approach-step-3-text',
  },
  {
    title: 'employers-care-approach-step-4-title',
    description: 'employers-care-approach-step-4-text',
  },
];
